import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Leads from "../Pages/Leads";
import Dashboard from "../Pages/Dashboard";
import CommonLayout from "../Components/Layouts/CommonLayout";
import Reporting from "../Pages/Reporting";
import LeadActivity from "../Pages/LeadActivity";
import AvailableInventory from "../Pages/AvailableInventory";
import AppraiserSetup from "../Pages/AppraiserSetup";
import FrontDealStatus from "../Pages/FrontDealStatus";
import FrontDealStatusStep2 from "../Pages/FrontDealStatusStep2";
import FrontDealStatusStep3 from "../Pages/FrontDealStatusStep3";
import FrontDealStatusStep4 from "../Pages/FrontDealStatusStep4";
import Lead from "../Components/Leads/Lead";
import Login from "../Components/Common/Login";

import { UserContext } from "../Components/Context/UserContext";
import { useEffect, useContext, useState } from 'react';
import AutoPilot from "../Components/AutoPilot/AutoPilot";
import AppraisalBuilder from "../Components/AppraisalBuilder/AppraisalBuilder";
import CustomersInQueue from "../Components/Customers/CustomersInQueue";
import { getImages } from "../Components/Const";
import EditAnnouncements from "../Pages/EditAnnouncements";
import AppraisalResults from "../Pages/AppraisalResults";
import AutoEmailer from "../Pages/AutoEmailer";
const PrivateRoute = ({ user }) => {
    return user && user.username && user.username !== "publicuser" ? (
        <Outlet />
    ) : (
        <Navigate to="/" replace />
    );
};
const AppRoutes = () => {
    const { user, loggedInCheck } = useContext(UserContext);

    const [checkedLogin, setCheckedLogin] = useState(null);

    useEffect(() => {
        if (!checkedLogin) {
            checkLogin();
        }
    }, []);

    const checkLogin = async () => {
        console.log('checking login');
        await loggedInCheck();
        setCheckedLogin(true);
        console.log(user);
    };
    if (!checkedLogin) {
        return <>
            <div className='loading-box py-5' style={{background: "transparent", borderRadius: "5px", margin: "10px auto"}}>
                <div className='lb-box'>
                    <div className="md-title text-center text-white fw-600 font-26">Loading</div>
                    <div className="float-points">
                        <div className="dot-collision"></div>
                    </div>
                    <div className='text-center gears-icon mt-4 mb-4'>
                        <img src={getImages('loading-red.svg')} alt='loading' />
                    </div>
                    <div className='xs-title text-center opacity-0-8 text-white'>This may take upto 10 seconds.<br />
                        Please don't refresh the browser.</div>
                </div>
            </div>
        </>; // Show a loader while checking login status
    }

    return (
        <Routes>
            <Route path="/" element={<Login />} />

            {/* Private Routes */}
            <Route element={<PrivateRoute user={user} />}>
                <Route path="dashboard" element={<Navigate to="/web" replace />} />
                <Route path="web" element={<CommonLayout />} />
                <Route path="reporting" element={<Reporting />} />
                <Route path="lead-activity" element={<LeadActivity />} />
                <Route path="available-inventory" element={<AvailableInventory />} />
                <Route path="appraiser-setup" element={<AppraiserSetup />} />
                <Route path="deal-status" element={<FrontDealStatus />} />
                <Route path="deal-status-step2" element={<FrontDealStatusStep2 />} />
                <Route path="deal-status-step3" element={<FrontDealStatusStep3 />} />
                <Route path="deal-status-step4" element={<FrontDealStatusStep4 />} />
                <Route path="lead" element={<Lead />} />
                <Route path="auto-pilot" element={<AutoPilot />} />
                <Route path="appraisal-builder" element={<AppraisalBuilder />} />
                <Route path="customers-in-queue" element={<Navigate to="/store" replace />} />
                <Route path="store" element={<CustomersInQueue />} />
                <Route path="edit-announcements" element={<EditAnnouncements />} />
                <Route path="search" element={<AppraisalResults />} />
                <Route path="auto-emailer" element={<AutoEmailer />} />
            </Route>
            <Route path="*" element={<Navigate to={user ? "/" : "/"} replace />} />
        </Routes>
    );
};

export default AppRoutes;
